<template>
  <div>
    <teleport to="#product-element__popup-container-vue">
      <transition name="fade">
        <div
          class="popup d-flex d-flex_middle d-flex_center d-flex_column"
          v-if="isReviewSent"
        >
          <div class="popup__layout" @click="closePopup()"></div>
          <div
            class="popup__wrap p-16 p-lg-0 scroll scroll_y w-100 active-move-down"
            v-bind:class="{
              'is-active': isReviewSent,
            }"
          >
            <div
              class="popup__block popup__block_xs bg-white radius-md p-20 mx-auto radius-lg-top-lr-md"
            >
              <div class="popup__content mx-auto">
                <div class="grid-row grid-row_md d-flex_reverse">
                  <div class="grid-col">
                    <div
                      class="btn color-gray hover-color-dark"
                      @click="closePopup()"
                    >
                      <Icon iconName="icon-close" className="icon-24" />
                    </div>
                  </div>

                  <div class="grid-col grid-col_full">
                    <div class="pl-40 text-center">
                      <img src="./../../assets/images/ok.svg" alt="ok" />
                    </div>
                  </div>
                </div>

                <div class="mt-12 text-center fs-20 fw-medium">
                  Спасибо за отзыв!
                </div>
                <div class="mt-8 text-center fs-14 fw-medium">
                  Мы опубликуем его в ближайшее время
                </div>
              </div>
            </div>
          </div>
          <!-- /popup__wrap -->
        </div>
      </transition>
    </teleport>
  </div>
</template>

<script>
import Icon from "../Icon/Icon.vue";
import { useReviewsStore } from "@/pages/product_card/stores/store_reviews";
import { mapState } from "pinia";

export default {
  name: "PopupLeaveReview",
  components: {
    Icon,
  },
  data() {
    return {
      isShow: false,
      isAnimate: false,
    };
  },
  setup() {
    const storeReviews = useReviewsStore();

    return {
      storeReviews,
    };
  },
  computed: {
    ...mapState(useReviewsStore, ["isReviewSent"]),
  },
  methods: {
    showPopup() {
      this.isShow = true;
      setTimeout(() => {
        this.isAnimate = true;
      }, 2);
    },
    closePopup() {
      this.storeReviews.reviewInProcess.sent = false;
    },
  },
};
</script>

<!-- <style lang="scss">
@import "./popup.scss";
</style> -->
